import { Modal as MortarModal } from '@policygenius/mortar';
import { useEffect, useRef } from 'react';

import { track } from 'analytics/frontend';

import { CLOSED_MODAL_EVENT, OPENED_MODAL_EVENT } from './constants';
import { ModalProps } from './types';

const Modal: React.FC<ModalProps> = ({ analyticsProperties, name, showModal, ...props }) => {
  const isMountRef = useRef(true);

  useEffect(() => {
    if (showModal) {
      track(OPENED_MODAL_EVENT, {
        modalId: name,
        ...analyticsProperties,
      });
    } else if (!isMountRef.current) {
      track(CLOSED_MODAL_EVENT, {
        modalId: name,
        ...analyticsProperties,
      });
    }

    isMountRef.current = false;
  }, [showModal]);

  return <MortarModal showModal={showModal} {...props} />;
};

export default Modal;
